import { Colors, FlexBox, SadFaceIcon, Text } from '@helloself/hello-self-ui';
import React from 'react';

import { Toolbar } from './Toolbar';

export type NoProfileFoundProps = {
    previewBackground?: {
        backgroundImage?: string;
        backgroundPosition?: string;
    };
};

export function NoProfileFound({ previewBackground }: NoProfileFoundProps) {
    return (
        <FlexBox
            {...previewBackground}
            backgroundRepeat="no-repeat"
            backgroundSize="contain"
            width="100%"
            height="100%"
            padding="62px 0px"
            justifyContent="center"
        >
            <FlexBox flexDirection="column" width="920px" gap="8px">
                {/* return false for own profile so the back button is returned instead */}
                <Toolbar isOwnProfile={false} />

                <FlexBox gap="24px">
                    <FlexBox
                        margin="24px 0"
                        padding="12px"
                        width="100%"
                        height="100%"
                        borderRadius="6px"
                        backgroundColor={Colors.white}
                        justifyContent="center"
                    >
                        <FlexBox width="50%" flexDirection="column" alignItems="center" padding="40px 0 0 0">
                            <SadFaceIcon width="48px" height="48px" />
                            <Text textColor={Colors.midGrey} fontWeight="600" textSize="xxxlarge" margin="24px 0 0 0">
                                Oops
                            </Text>
                            <Text textColor={Colors.midGrey} fontWeight="600" textAlign="center" margin="8px 0 0 0">
                                We couldn't find this profile.
                            </Text>
                        </FlexBox>
                    </FlexBox>
                </FlexBox>
            </FlexBox>
        </FlexBox>
    );
}
